import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { AZLogo, ELogoType } from '../AZLogo';
import { Copyright } from '../Copyright';
import styles from './Footer.css';
export const Footer = memo(function Footer({ children, className }) {
    return (_jsxs("footer", Object.assign({ className: `${styles.footer} ${className}`, "aria-label": "footer" }, { children: [_jsxs("div", Object.assign({ className: styles.leftBlock }, { children: [_jsx(AZLogo, { className: styles.logo, type: ELogoType.White }, void 0), children] }), void 0), _jsx(Copyright, {}, void 0)] }), void 0));
});
